import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useSubscription } from '../../context/SubscriptionContext';
import { ArrowLeft, User, CreditCard, Crown, LogOut, Zap, Star } from 'lucide-react';
import './Auth.css';

const AccountPage = ({ onBack, onUpgrade }) => {
  const { currentUser, logout } = useAuth();
  const { currentTier, getTierConfig, subscriptionData } = useSubscription();

  const tierConfig = getTierConfig();

  const handleLogout = () => {
    if (onBack) onBack();
    logout();
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const getTierIcon = () => {
    switch (currentTier) {
      case 'super':
        return <Crown size={20} />;
      case 'advanced':
        return <Star size={20} />;
      case 'pro':
      case 'basic':
        return <Zap size={20} />;
      default:
        return <User size={20} />;
    }
  };

  return (
    <div className="account-page">
      <div className="account-header">
        <button className="account-back-btn" onClick={onBack}>
          <ArrowLeft size={18} />
          Back
        </button>
        <h1>My Account</h1>
      </div>

      <div className="account-cards">
        <div className="account-card">
          <h2>
            <User size={20} />
            Profile Information
          </h2>
          <div className="profile-info">
            <div className="info-row">
              <span className="label">Display Name</span>
              <span className="value">{currentUser?.displayName || 'Not set'}</span>
            </div>
            <div className="info-row">
              <span className="label">Username</span>
              <span className="value">@{currentUser?.username}</span>
            </div>
            <div className="info-row">
              <span className="label">Member Since</span>
              <span className="value">{formatDate(currentUser?.createdAt)}</span>
            </div>
          </div>
        </div>

        <div className="account-card">
          <h2>
            <CreditCard size={20} />
            Subscription
          </h2>
          
          <div className="subscription-status">
            <span className={`tier-badge ${currentTier}`}>
              {getTierIcon()}
            </span>
            <div className="subscription-details">
              <div className="tier-name">{tierConfig.name}</div>
              <div className="tier-price">{tierConfig.displayPrice}</div>
            </div>
          </div>

          {subscriptionData.startDate && (
            <div className="profile-info">
              <div className="info-row">
                <span className="label">Started</span>
                <span className="value">{formatDate(subscriptionData.startDate)}</span>
              </div>
              {subscriptionData.endDate && (
                <div className="info-row">
                  <span className="label">Expires</span>
                  <span className="value">{formatDate(subscriptionData.endDate)}</span>
                </div>
              )}
            </div>
          )}

          {currentTier === 'free' && (
            <div className="upgrade-prompt">
              <Crown size={20} />
              <span>Upgrade to unlock all wizards, reports, and premium features!</span>
            </div>
          )}

          <div className="account-actions">
            {currentTier !== 'super' && (
              <button className="upgrade-btn-account" onClick={onUpgrade}>
                <Crown size={18} />
                {currentTier === 'free' ? 'Upgrade Now' : 'Change Plan'}
              </button>
            )}
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={18} />
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
